import { css } from 'lit';
export default css `
    :host {
        --modal-dialog-position: absolute;
        --modal-dialog-radius: 0;
        --modal-header-inline-padding: var(--spacing-m);
        --modal-heading-padding: var(--spacing-xxxxl) 0 0 0;
        --modal-content-block-padding: var(--spacing-m);
        --modal-content-inline-padding: var(--spacing-m);
    }

    :host([anchor='block-start']),
    :host([anchor='block-end']) {
        --modal-dialog-max-height: calc(100% - 1.5 * var(--spacing-xxxxl));
        --modal-dialog-max-width: 100%;
        --modal-dialog-inset-inline-start: 0;
        --modal-dialog-inset-inline-end: 0;
        --modal-dialog-transform-translate-x: 0;
    }

    :host([anchor='block-start'][visible]),
    :host([anchor='block-end'][visible]) {
        --modal-dialog-transform-translate-y: 0;
    }

    :host([anchor='block-start']) {
        --modal-dialog-inset-block-start: 0;
        --modal-dialog-inset-block-end: auto;
        --modal-dialog-transform-translate-y: -100%;
    }

    :host([anchor='block-end']) {
        --modal-dialog-inset-block-start: auto;
        --modal-dialog-inset-block-end: 0;
        --modal-dialog-transform-translate-y: 100%;
    }

    :host([anchor='inline-start']),
    :host([anchor='inline-end']) {
        --modal-dialog-width: 504px
            /* Magic string… err, number. This is a one-off, special case because it's based on grid + page bleed */;
        --modal-dialog-max-height: 100%;
        --modal-dialog-max-width: calc(100% - var(--spacing-xxxxxl));
        --modal-dialog-inset-block-start: 0;
        --modal-dialog-inset-block-end: 0;
        --modal-dialog-transform-translate-y: 0;
    }

    :host([anchor='inline-start'][visible]),
    :host([anchor='inline-end'][visible]) {
        --modal-dialog-transform-translate-x: 0;
    }

    :host([anchor='inline-start']) {
        --modal-dialog-inset-inline-start: 0;
        --modal-dialog-inset-inline-end: auto;
        --modal-dialog-transform-translate-x: -100%;
    }

    :host([anchor='inline-end']) {
        --modal-dialog-inset-inline-start: auto;
        --modal-dialog-inset-inline-end: 0;
        --modal-dialog-transform-translate-x: 100%;
    }
`;
